/* eslint-disable react/no-array-index-key */
/* eslint-disable react/prop-types */
import React, { useState } from 'react'
import uniqueId from 'lodash/uniqueId'
import PopulateDefaults from './Defaults/Settings'

// VISUAL COMPONENT HELPERS
import NamePlate from './Header/NamePlate'
import Border from './Header/Border'
import Stripes from './Defs/Stripes'
import DoubleStripes from './Defs/DoubleStripes'
import Textures from './Defs/Textures'
import SourcePlate from './Footer/SourcePlate'

// VISUALS
import Pitches from './Chart/Pitch/Pitches'
import Zone from './Chart/Pitch/Zone'
import HexBin from './Chart/Pitch/HexBin'
import Contour from './Chart/Pitch/Contour'
import PitchPie from './Chart/Pitch/Pie'
import CirclePack from './Chart/Network/CirclePack'
import PieChart from './Chart/Network/PieChart'
import ReleasePoint from './Chart/ReleasePoint/ReleasePoint'
import Scatter from './Chart/Scatter/Scatter'
import LineGraph from './Chart/Line/LineGraph'
import FieldSVG from './Chart/Helpers/FieldSVG'
import Spray from './Chart/Field/Spray'
import Boxes from './Chart/Field/Boxes'
import FieldContour from './Chart/Field/Contour'
import SprayHexBin from './Chart/Field/HexBin'
import Radial from './Chart/Radial/Radial'
import Sideways from './Chart/Sideways/Sideways'
import Axis from './Chart/Pitch/Spin/Axis'

import ThreeD from './3d/3d'

// LEGENDS
import Legend from './Legend/Legend'
import HomeRunsLegend from './Legend/HomeRunsLegend'

/// VISUAL HELPERS
import FieldDegreeMarkers from './Chart/Helpers/FieldDegreeMarkers'
import HomePlate from './Chart/Helpers/HomePlate'
import StrikeZone from './Chart/Helpers/StrikeZone'
import RightHandedBatter from './Chart/Helpers/RightHandedBatter'
import LeftHandedBatter from './Chart/Helpers/LeftHandedBatter'

import './Stylesheets/styles.css'

export default function Visual({
    data = [],
    chart = {
        shape: 'snap',
        shapeRatio: 1,
        charts: [],
        namePlate: {
            show: true,
            background: 'stripes',
            backgroundColor: '#fff',
            titleFontColor: '#000',
            primaryTitleText: '',
            secondaryTitleText: '',
            secondaryFontColor: '#a9a9a9',
            tertiaryTitleText: '',
            tertiaryFontColor: '#000',
        },
        sourcePlate: {
            show: true,
            background: 'none',
            backgroundColor: '#c2c2c2',
            siteTitle: 'SAVANT',
            siteColor: '#32858d',
            sourceTitle: 'SOURCE: MLB.COM',
            sourceColor: '#000',
        },
        venueId: '7',
        mainPanelBackground: 'none',
        showToolTip: false,
        embedStyle: {},
        pitcherPerspective: false,
    },
}) {
    // Settings JSON
    // Powers the entire visualization
    const settings = PopulateDefaults(data, chart)
    let wasFieldAdded = false

    const [id] = useState(uniqueId('svg-'))
    return (
        <svg
            key="svg_source"
            id={id}
            width={settings.ratioWidth}
            height={settings.ratioHeight}
            viewBox={`0 0 ${settings.svgWidth} ${settings.svgHeight}`}
        >
            <defs key="defs">
                <Stripes />
                <DoubleStripes />
                <Textures />

                {chart.embedStyle ? (
                    <style
                        // eslint-disable-next-line react/no-danger
                        dangerouslySetInnerHTML={{ __html: chart.embedStyle }}
                    />
                ) : null}
            </defs>
            <Border key="border" settings={settings} />
            <g
                key="gHolder"
                transform={`scale(${
                    settings.vizScaleOverride || settings.vizScale
                }) translate(${settings.vizPadding.left},${
                    settings.vizPadding.top
                })`}
            >
                <rect
                    key="rect-background"
                    width={settings.vizWidth}
                    height={settings.vizHeight}
                    fill="none"
                    stroke="none"
                />
                <g key="rect-transform" transform={settings.svgZoom || null}>
                    {settings.charts.map((c, i) => {
                        if (c.chartType === 'pitch')
                            return (
                                <React.Fragment key={`frag_${i}`}>
                                    {c.showRHB ? (
                                        <RightHandedBatter
                                            key="rhb"
                                            pitcherPerspective={
                                                c.pitcherPerspective
                                            }
                                        />
                                    ) : null}
                                    {c.showLHB ? (
                                        <LeftHandedBatter
                                            key="lhb"
                                            pitcherPerspective={
                                                c.pitcherPerspective
                                            }
                                        />
                                    ) : null}
                                    {c.showPlate ? (
                                        <HomePlate
                                            key="homePlate"
                                            settings={settings}
                                            pitcherPerspective={
                                                c.pitcherPerspective
                                            }
                                        />
                                    ) : null}

                                    {c.overlayType === 'pie' &&
                                    data.length > 0 ? (
                                        <PitchPie
                                            key={`chart_${c.overlayType}`}
                                            settings={settings}
                                            chartOptions={c}
                                        />
                                    ) : null}

                                    {c.overlayType === 'pitch' ? (
                                        <Pitches
                                            key={`chart_${c.overlayType}`}
                                            settings={settings}
                                            chartOptions={c}
                                        />
                                    ) : null}

                                    {c.overlayType === 'zone' ? (
                                        <Zone
                                            key={`chart_${c.overlayType}`}
                                            settings={settings}
                                            chartOptions={c}
                                        />
                                    ) : null}

                                    {c.overlayType === 'contour' &&
                                    data.length > 0 ? (
                                        <Contour
                                            key={`chart_${c.overlayType}`}
                                            settings={settings}
                                            chartOptions={c}
                                        />
                                    ) : null}
                                    {c.overlayType === 'hexbin' &&
                                    data.length > 0 ? (
                                        <HexBin
                                            key={`chart_${c.overlayType}`}
                                            settings={settings}
                                            chartOptions={c}
                                        />
                                    ) : null}
                                    {c.overlayType === 'spinAxis' &&
                                    data.length > 0 ? (
                                        <Axis
                                            key={`chart_${c.overlayType}`}
                                            settings={settings}
                                            chartOptions={c}
                                        />
                                    ) : null}
                                    {c.showStrikeZone ? (
                                        <StrikeZone
                                            key="strikeZone"
                                            settings={settings}
                                            chartOptions={c}
                                        />
                                    ) : null}
                                </React.Fragment>
                            )
                        if (c.chartType === 'line')
                            return (
                                <React.Fragment key={`frag_${i}`}>
                                    <LineGraph
                                        key="lineChart"
                                        settings={settings}
                                        chartOptions={c}
                                    />
                                </React.Fragment>
                            )
                        if (c.chartType === 'network')
                            return (
                                <React.Fragment key={`frag_${i}`}>
                                    {c.overlayType === 'circlePack' ? (
                                        <CirclePack
                                            key={`chart_${c.overlayType}`}
                                            settings={settings}
                                            chartOptions={c}
                                        />
                                    ) : null}
                                    {c.overlayType === 'pie' ? (
                                        <PieChart
                                            key={`chart_${c.overlayType}`}
                                            settings={settings}
                                            chartOptions={c}
                                        />
                                    ) : null}
                                    <Legend
                                        key="legend"
                                        settings={settings}
                                        type="pitchName"
                                    />
                                </React.Fragment>
                            )

                        if (c.chartType === 'release')
                            return (
                                <ReleasePoint
                                    key={`releasePoint_${i}`}
                                    settings={settings}
                                    chartOptions={c}
                                />
                            )
                        if (c.chartType === 'movement') {
                            return (
                                <Scatter
                                    key={`scatter_${i}`}
                                    settings={settings}
                                    chartOptions={c}
                                />
                            )
                        }

                        if (c.chartType === 'radial')
                            return (
                                <React.Fragment key={`radial_${i}`}>
                                    <Radial
                                        settings={settings}
                                        chartOptions={c}
                                    />
                                </React.Fragment>
                            )
                        if (c.chartType === 'sideways')
                            return (
                                <React.Fragment key={`sideways_${i}`}>
                                    <Sideways
                                        settings={settings}
                                        chartOptions={c}
                                    />
                                </React.Fragment>
                            )
                        if (c.chartType === 'field') {
                            let field = null
                            if (!wasFieldAdded) {
                                field = (
                                    <FieldSVG
                                        settings={settings}
                                        chartOptions={c}
                                        venueId={chart.venueId}
                                    />
                                )
                                wasFieldAdded = true
                            }
                            return (
                                <React.Fragment key={`frag_${i}`}>
                                    {field}
                                    {c.showFieldDegreeMarkers ? (
                                        <FieldDegreeMarkers
                                            settings={settings}
                                        />
                                    ) : null}
                                    {c.overlayType === 'spray' ? (
                                        <Spray
                                            settings={settings}
                                            chartOptions={c}
                                        />
                                    ) : null}
                                    {c.overlayType === 'contour' ? (
                                        <FieldContour
                                            settings={settings}
                                            chartOptions={c}
                                        />
                                    ) : null}
                                    {c.overlayType === 'hexbin' ? (
                                        <SprayHexBin
                                            settings={settings}
                                            chartOptions={c}
                                        />
                                    ) : null}
                                    {c.overlayType === 'boxes' ? (
                                        <Boxes
                                            settings={settings}
                                            chartOptions={c}
                                        />
                                    ) : null}
                                </React.Fragment>
                            )
                        }
                        if (c.chartType === '3d') {
                            return (() => (
                                <React.Fragment key={`threeD_${i}`}>
                                    <foreignObject
                                        width={settings.vizWidth}
                                        height={settings.vizHeight}
                                    >
                                        <ThreeD
                                            settings={settings}
                                            chartOptions={c}
                                        />
                                    </foreignObject>
                                    {c.overlayType === 'spray' ? (
                                        <Legend
                                            settings={settings}
                                            type={c.legendType}
                                            chartOptions={c}
                                        />
                                    ) : null}
                                    {c.overlayType === 'trajectory' &&
                                    c.legend ? (
                                        <HomeRunsLegend
                                            settings={settings}
                                            type={c.legendType}
                                            chartOptions={c}
                                        />
                                    ) : null}
                                </React.Fragment>
                            ))()
                        }
                        return null
                    })}
                </g>
                {settings.toolTip ? (
                    <g key="tooltip" ref={settings.toolTip} />
                ) : null}
            </g>
            {chart.namePlate.show ? <NamePlate settings={settings} /> : null}
            {chart.sourcePlate.show ? (
                <SourcePlate settings={settings} />
            ) : null}
        </svg>
    )
}
